// import { NgModule } from '@angular/core';
// import { Routes, RouterModule } from '@angular/router';
// import { DashboardResolveService } from './sheba/dashboard/dashboard-resolve.service';
//
// const routes: Routes = [
//     {
//         path: 'dashboard',
//         loadChildren: './sheba/dashboard/dashboard.module#DashboardModule',
//         canLoad: [ DashboardResolveService ],
//         resolve: { user: DashboardResolveService },
//     },
//     {
//         path: '',
//         loadChildren: './sheba/general-root/general-root.module#GeneralRootModule',
//         canLoad: [ DashboardResolveService ],
//     },
//     {
//         path: '**',
//         loadChildren: './modules/not-found/not-found.module#NotFoundModule'
//     }
// ];
//
// @NgModule({
//     imports: [RouterModule.forRoot(routes)],
//     exports: [RouterModule]
// })
//
// export class AppRoutingModule { }

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { RfqCreateComponent } from './sheba/dashboard/rfq/rfq-create/rfq-create.component';

const routes: Routes = [

    { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },

  // Lazy load DashboardModule
  { path: 'dashboard', loadChildren: './sheba/dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },

  { path: '**', redirectTo: '/login' }
    
   
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
